import { applyMiddleware, combineReducers, createStore } from 'redux';
import { default as thunkMiddleware } from 'redux-thunk';

import objectErrorFormReducer, {
  IObjectErrorFormState,
} from '../bundles/business_shopping_center_detail/components/object_error_form/reducers/object_error_form_reducer';
import formReducer, { IFormState } from '../bundles/form/reducers/form';
import popupReducer, { IPopupState } from '../bundles/popup/reducers/popup';
import priceChangeSubscriptionReducer, {
  IPriceChangeSubscriptionState,
} from '../bundles/price_change_subscription/reducers/price_change_subscription';
import userClaimsReducer, { IUserClaimsState } from '../bundles/user_claims/reducers/user_claims';

export interface IApplicationState {
  form: IFormState;
  userClaims: IUserClaimsState;
  objectErrorForm: IObjectErrorFormState;
  popup: IPopupState;
  priceChangeSubscription: IPriceChangeSubscriptionState;
}

let finalCreateStore = createStore;

finalCreateStore = applyMiddleware(
  thunkMiddleware
)(finalCreateStore);

const store = finalCreateStore<IApplicationState>(combineReducers<IApplicationState>({
  form: formReducer,
  objectErrorForm: objectErrorFormReducer,
  popup: popupReducer,
  priceChangeSubscription: priceChangeSubscriptionReducer,
  userClaims: userClaimsReducer,
}));

export default store;



// WEBPACK FOOTER //
// ./src/di/store.ts